// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3ILIH","sendOtp":"AuthorizeToLogin_sendOtp__1YQzm"};